import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "base-button__content" }
const _hoisted_3 = {
  key: 0,
  class: "base-button__text"
}
const _hoisted_4 = {
  key: 0,
  class: "base-button__spinner"
}

import { computed } from 'vue'
import Spinner from '@/components/common/Spinner.vue'

export interface Props {
  text?: string;
  isDisabled: boolean;
  isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    text: null,
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { text?: string, isDisabled: boolean, isLoading: boolean };



const buttonDisabledClass = computed(() =>
  props.isDisabled === true ? 'base-button--disabled' : '')
const buttonLoaderClass = computed(() =>
  props.isLoading === true ? 'base-button--loader' : '')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['base-button', _unref(buttonLoaderClass), _unref(buttonDisabledClass)]),
    disabled: __props.isDisabled || __props.isLoading
  }, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      (__props.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.text), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createVNode(Spinner)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})